module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("buEkq"))).then(() => module.bundle.root('ljYL6'));